import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Row } from "antd";
import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";

export interface AudienceModalFiltersProps {
	onFinish?: (values: any) => void;
	disabled?: boolean;
}

const AudienceModalFilters: React.FC<AudienceModalFiltersProps> = ({
	onFinish,
	disabled = false,
}) => {
	const { searchForm, sections, step, type } = useAudienceModalContext();

	// Only show filters in search step
	if (step !== "search") {
		return null;
	}

	const isViewMode = type === "view";

	return (
		<Col xs={24} className="mb-4 p-4 bg-gray-100">
			<Form
				form={searchForm}
				layout="vertical"
				onFinish={onFinish}
				disabled={disabled || isViewMode}
			>
				{sections.map((section) => (
					<div key={section.key}>{section.content}</div>
				))}

				<Divider />
				<Form.Item className="mb-0">
					<Row gutter={[8, 8]} justify="center">
						<Col>
							<Button
								type="dashed"
								icon={<SearchOutlined />}
								size="large"
								className="bg-white px-6"
								htmlType="submit"
							>
								検索
							</Button>
						</Col>
					</Row>
				</Form.Item>
			</Form>
		</Col>
	);
};

export default AudienceModalFilters;
